import { HandlingTypeEnum } from './enums/handling-type.enum';
import { Transport } from './transport.model';
import { LIST_MEASURE_UNIT, LIST_VEHICLE_CATEGORY, LIST_VEHICLE_TYPE, MeasureUnit, MeasureUnitEnum, VehicleCategory, VehicleType } from './vehicle.model';
import { TransportOrder } from './transport-order.model';

export class TransportItem {
  public id?: number;
  public handlingType!: HandlingTypeEnum;
  public dimension?: number; //Id de la dimension sélectionnée
  public length?: number;
  public width?: number;
  public maxHeight?: number;
  public weight?: number; //Poids par unité
  public quantity?: number;
  public groundPalletQuantity?: number;
  public otherSpecificQuantity?: number;
  public transport?: Transport;
  public transportOrder?: TransportOrder;
  public description?: string;
  public other?: number;
  public vehicleCategory?: VehicleCategory;
  public vehicleType?: VehicleType;
  public lengthUnit?: MeasureUnit;
  public weightUnit?: MeasureUnit;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.length = data.length ? +data.length : undefined;
    this.width = data.width ? +data.width : undefined;
    this.maxHeight = data.maxHeight ? +data.maxHeight : undefined;
    this.weight = data.weight ? +data.weight / +(data.quantity || 1) : undefined; //On recupere le poids total, il faut donc le diviser pour obtenir le poids par unité
    this.quantity = data.quantity ? +data.quantity : undefined;
    this.other = data.other ? +data.other : undefined;
    this.transport = data.transport?.id ? new Transport(data.transport) : undefined;
    this.transportOrder = data.transportOrder?.id ? new TransportOrder(data.transportOrder) : undefined;
    this.vehicleCategory = data.vehicleCategory ? LIST_VEHICLE_CATEGORY[data.vehicleCategory] : undefined;
    this.vehicleType = data.vehicleType ? LIST_VEHICLE_TYPE[data.vehicleType] : undefined;

    this.lengthUnit = data.lengthUnit ? LIST_MEASURE_UNIT[data.lengthUnit] : LIST_MEASURE_UNIT[MeasureUnitEnum.CENTIMETER];
    this.weightUnit = data.weightUnit ? LIST_MEASURE_UNIT[data.weightUnit] : LIST_MEASURE_UNIT[MeasureUnitEnum.KG];
  }

  public serialize(): any {
    if (this.length && this.width && this.length < this.width) {
      let temp = this.length;
      this.length = this.width;
      this.width = temp;
    }
    return {
      id: this.id,
      handlingType: this.handlingType,
      dimension: this.dimension,
      length: this.length,
      width: this.width,
      maxHeight: this.maxHeight,
      weight: this.weight ? +(this.weight * (this.quantity || 1)).toFixed(1) : this.weight,
      quantity: this.quantity,
      groundPalletQuantity: this.groundPalletQuantity,
      otherSpecificQuantity: this.otherSpecificQuantity,
      transport: this.transport?.id ? { id: this.transport?.id } : undefined,
      transportOrder: this.transportOrder?.id ? { id: this.transportOrder?.id } : undefined,
      description: this.description,
      other: this.other?.toFixed(1),
      vehicleCategory: this.vehicleCategory?.code,
      vehicleType: this.vehicleType?.code,
      lengthUnit: this.lengthUnit?.value,
      weightUnit: this.weightUnit?.value,
    };
  }
}
